import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Button,
  FormCheckbox,
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
} from 'semantic-ui-react';

const MISMATCH_KTP_DETAIL_AND_PHOTO = 'Mismatch KTP detail and photo';
const KTP_PHOTO_NOT_CLEAR = 'KTP photo not clear';

function KybRejectConfirmationModal({ shown, onClose, onConfirm, isLoading }) {
  const [mismatchDetailAndPhoto, setMismatchDetailAndPhoto] = useState(false);
  const [photoNotClear, setPhotoNotClear] = useState(false);

  useEffect(() => {
    if (!shown) {
      setMismatchDetailAndPhoto(false);
      setPhotoNotClear(false);
    }
  }, [shown]);

  const onConfirmButtonClicked = () => {
    const reasons = [];
    if (mismatchDetailAndPhoto) {
      reasons.push(MISMATCH_KTP_DETAIL_AND_PHOTO);
    }
    if (photoNotClear) {
      reasons.push(KTP_PHOTO_NOT_CLEAR);
    }
    onConfirm(reasons.join(', '));
  };

  return (
    <Modal open={shown} onClose={onClose}>
      <ModalHeader>Confirm Reject KYB</ModalHeader>
      <ModalContent>
        <p>Rejection Reasons</p>
        <em>Why do you reject merchant&#39;s data provided?</em>
        <br />
        <Form>
          <FormCheckbox
            label={MISMATCH_KTP_DETAIL_AND_PHOTO}
            checked={mismatchDetailAndPhoto}
            onChange={() => setMismatchDetailAndPhoto(!mismatchDetailAndPhoto)}
            disabled={isLoading}
          />
          <FormCheckbox
            label={KTP_PHOTO_NOT_CLEAR}
            checked={photoNotClear}
            onChange={() => setPhotoNotClear(!photoNotClear)}
            disabled={isLoading}
          />
        </Form>
      </ModalContent>
      <ModalActions>
        <Button onClick={onClose} loading={isLoading} disabled={isLoading}>
          Cancel
        </Button>
        <Button
          negative
          onClick={onConfirmButtonClicked}
          loading={isLoading}
          disabled={isLoading || (!mismatchDetailAndPhoto && !photoNotClear)}
        >
          Confirm
        </Button>
      </ModalActions>
    </Modal>
  );
}

KybRejectConfirmationModal.propTypes = {
  shown: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default KybRejectConfirmationModal;
